<template>
  <main>
    <Login class="absolute w-screen h-screen bg-cover" />
    <div class="flex min-h-screen">
      <div
        class="flex flex-grow flex-col relative mt-40 bg-white justify-between"
      >
        <div class="flex flex-1 items-start justify-start">
          <slot />
        </div>
        <Footer v-if="showFooter" />
        <footer
          v-else
          class="flex w-full justify-evenly sm:justify-between border-t border-2 border-gray-200 p-8 sm:p-24"
        >
          <HMButton
            rounded="full"
            outlined
            class="button--white-outlined w-130 xxs:w-5/12 xs:w-200"
            @click="hasBackButton ? $emit('back') : $router.back()"
            >{{
              hasBackButton ? $t('common.back_btn') : $t('common.cancel_btn')
            }}</HMButton
          >
          <HMButton
            class="w-130 xxs:w-5/12 xs:w-200"
            rounded="full"
            :disabled="isNextButtonDisabled"
            @click="$emit('next')"
            >{{ nextButtonLabel }}</HMButton
          >
        </footer>
      </div>
    </div>
  </main>
</template>

<script>
import { Login } from '@assets/svgs/index'
import Footer from '../common/Footer.vue'

export default {
  components: { Login, Footer },
  props: {
    isNextButtonDisabled: {
      type: Boolean,
      default: false,
    },
    nextButtonLabel: {
      type: String,
      required: true,
    },
    showFooter: {
      type: Boolean,
      default: false,
    },
    hasBackButton: {
      type: Boolean,
      default: false,
    },
  },
}
</script>
